import React, { useEffect, useRef } from 'react';

export const useEffectWithoutFirstRenderHook = (cb: React.EffectCallback, deps?: React.DependencyList): void => {
  const isFirstTime = useRef(true);

  useEffect(() => {
    if (isFirstTime.current) {
      isFirstTime.current = false;
    } else {
      return cb();
    }
    return (): void => {};
  }, deps);
};

export const useEffectOnceHook = (effect: () => void, deps?: React.DependencyList): void => {
  const initialRef = useRef(true);

  useEffect(() => {
    if (!initialRef.current) {
      return;
    }
    initialRef.current = false;
    if (deps && deps[0]) effect();
  }, [deps || []]);
};
